var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.valid)?_c('v-btn',{attrs:{"loading":_vm.loading,"outlined":"","small":"","color":"secondary"},on:{"click":function($event){return _vm.remind()}}},[_vm._v("Remind")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }